/* istanbul ignore file */
// TODO: Create test file

import useEnvProps from '../env-props/useEnvProps';
import { VIRTUAL_ADVISOR_SKELETON_DATA } from '../../constants/SalesFloor';

export default function useVirtualAdvisor({ virtualAdvisorWidgetName }) {
  const { entryPoint } = useEnvProps();
  return {
    virtualAdvisorLoaderProps: VIRTUAL_ADVISOR_SKELETON_DATA?.[virtualAdvisorWidgetName]?.attrs ?? {},
    virtualAdvisorSkeletonClass: [
        `skeleton-loader--virtual-advisor--${virtualAdvisorWidgetName}`,
        ...VIRTUAL_ADVISOR_SKELETON_DATA?.[virtualAdvisorWidgetName]?.classes?.[entryPoint.value],
    ],
  };
}
